export default "__VITE_ASSET__BpPvQikt__"